import React from 'react'
import { PatientPreferencesMenu } from '../../../../../../../../containers/patient-preferences-menu'

export default function MenuButtonsWrapper(props) {
  return <PatientPreferencesMenu {...props} />
}
